module.exports = __webpack_public_path__ + "static/img/blog-6-economic-times.57fbef15.webp";